import { Skeleton } from '@/shared/components/ui/skeleton';
import { Separator } from '@/shared/components/ui/separator';

/**
 * Loading skeleton for `WorkScheduleSection`.
 * Mirrors the tenant form (header + two fields + button) and a few list rows.
 */
export function WorkScheduleSectionSkeleton() {
  return (
    <div className="space-y-8" data-testid="work-schedules-loading-skeleton">
      <div>
        <Skeleton className="h-6 w-56" />
        <Skeleton className="mt-2 h-4 w-80" />
        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
        </div>
        <div className="mt-6 flex justify-end">
          <Skeleton className="h-10 w-40" />
        </div>
      </div>

      <Separator />

      <div className="space-y-3">
        <Skeleton className="h-6 w-48" />
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} className="h-14 w-full rounded-lg" />
        ))}
      </div>
    </div>
  );
}
